// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--+ds4F";
export var headingText = "heading-module--headingText--kyQRS";
export var show = "heading-module--show--j-uSK";
export var subheading = "heading-module--subheading--dZGed";